import React from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { Tabs } from "react-simple-tabs-component";
import "react-simple-tabs-component/dist/index.css";
import axios from "axios";
import _ from "lodash";

import { TaggedContentCard, UserCard, ProductCard } from "react-ui-cards";
import Profile from "./pages/profile/profile";
import Home from "./pages/home/home";
import Solutions from "./pages/solutions/solutions";
import About from "./pages/about/about";
import Press from "./pages/press/press";
import Work from "./pages/work/work";
import Cookie from "./pages/cookie/cookie";
import Privacy from "./pages/privacy/privacy";
import Questions from "./pages/questions/questions";
import Product from "./pages/product/product";
import Admin from "./pages/admin/admin";
import Create from "./pages/create/create";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Modal,
  Box,
  Typography,
  CircularProgress,
  Stack,
  Alert,
  AlertTitle,
  Chip,
  TextField,
  Pagination,
} from "@mui/material";

import "./App.css";
import WhiteLabelPage from "./pages/white-label/white-label";
import TermsOfServicePage from "./pages/terms-of-service/terms-of-service";

function App() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Website",
    name: "123Skincare",
    url: "https://www.123skincare.pro/",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate:
          "https://www.123skincare.pro//questions?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  };

  let containerClass = "ott-container";
  /*if (window.location.pathname === '/white-label') {
    containerClass = "container"
  }*/

  return (
    <div className="App">
      {window.location.pathname === "/" ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(structuredData),
          }}
        />
      ) : (
        ""
      )}

      <div className={`${ containerClass }`}>
        {/* Define all the routes */}
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/home" element={<Home />}></Route>
          {/*<Route path="/secure/admin" element={<Admin />}></Route>*/}
          {/*<Route path="/secure/create" element={<Create />}></Route>*/}
          <Route path="/solutions" element={<Solutions />}></Route>
          <Route path="/about" element={<About />}></Route>
          {/*<Route path="/press" element={<Press />}></Route>*/}
          <Route path="/about#work-with-us" element={<Work />}></Route>
          <Route path="/privacy" element={<Privacy />}></Route>
          <Route path="/cookie" element={<Cookie />}></Route>
          <Route path="/questions" element={<Questions />}></Route>
          <Route path="/product" element={<Product />}></Route>
          <Route path="/white-label" element={<WhiteLabelPage />}></Route>
          <Route path="/terms-of-service" element={<TermsOfServicePage />}></Route>
          <Route path="*" element={<Home />}></Route>
        </Routes>
      </div>
    </div>
  );
}

export default App;
